import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../../Common/CommonVariables'

export const GetCountryList = async() => {
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + 'Country/GetAllCountryList'), 
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const CreateNewCountry = async (countryDet) => {
    //debugger;
    //console.log(JSON.stringify(countryDet))
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + `Country/CreateNewCountry`, 
        JSON.stringify(countryDet), 
        CommonVariables.API_HEADER)
        ).then(response => response);
    return result;
}

export const ActivateDeActivateCountry = async(Id, IsActive) => {
    //debugger;
    var result = await trackPromise(
        axios.get(CommonVariables.API_DOMAIN + `Country/ActivateDeActivateCountry?countryId=${Id}&IsActive=${IsActive}`),
        CommonVariables.API_HEADER
    ).then(response => response)
    return result;
}

export const UpdateCountry = async(countryDet) =>{
    var result = await trackPromise(
        axios.post(CommonVariables.API_DOMAIN + 'Country/UpdateCountry', 
        JSON.stringify(countryDet),
        CommonVariables.API_HEADER)
    ).then(response => response)
    return result;
}